export default __webpack_public_path__ + "static/media/physician-header-bg.35d7d0dc.svg";